export const API_EXTERNAL_ENDPOINT = 'regions'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/regions/list'
